import type { EnrollmentEsOpsCallFailureRow, EnrollmentEsOpsFailureRow } from "./enrollmentTypes";
import { EnrollmentCallGapsSection } from "./enrollmentCallGapsSection";
import {
  ErrorState,
  EsOpsCallFailureTable,
  EsOpsFailureTable,
  LoadingState,
  SectionDivider,
} from "./enrollmentUi";

export function EnrollmentWeeklyTab(props: {
  callRows: EnrollmentEsOpsCallFailureRow[];
  error: string;
  esOpsDate: string;
  esOpsDates: string[];
  loading: boolean;
  rows: EnrollmentEsOpsFailureRow[];
  setEsOpsDate: (date: string) => void;
}) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-sm font-semibold text-foreground">Day of analysis:</span>
        <div className="flex flex-wrap gap-1.5">
          {props.esOpsDates.map((date) => (
            <button
              key={date}
              type="button"
              onClick={() => props.setEsOpsDate(date)}
              className={
                props.esOpsDate === date
                  ? "rounded-md border-2 border-foreground bg-muted px-2.5 py-1 text-xs font-semibold"
                  : "rounded-md border border-border bg-background px-2.5 py-1 text-xs text-muted-foreground"
              }
            >
              {date}
            </button>
          ))}
        </div>
      </div>

      <SectionDivider label="Failure to create carespace" />
      {props.loading ? (
        <LoadingState />
      ) : props.error ? (
        <ErrorState message={props.error} />
      ) : (
        <EsOpsFailureTable rows={props.rows} />
      )}

      <SectionDivider label="Failure to call" />
      {props.loading ? (
        <LoadingState />
      ) : props.error ? (
        <ErrorState message={props.error} />
      ) : (
        <EsOpsCallFailureTable rows={props.callRows} />
      )}
      <EnrollmentCallGapsSection />
    </div>
  );
}
